var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 160 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.599 51.726H122.394L134.403 8.72195C135.01 6.6626 134.525 4.36098 133.312 2.66504C131.977 0.969106 129.915 0 127.853 0H38.9381C35.6629 0 32.9943 2.18049 32.2665 5.33008L0 142.943H14.1924L44.3967 13.6886H118.877L106.868 56.6927C106.261 58.752 106.746 61.0537 107.959 62.7496C109.294 64.4455 111.356 65.4146 113.418 65.4146H139.013L95.1012 124.651L102.015 84.5545C102.379 82.4951 101.773 80.5569 100.439 78.9821C99.1042 77.4073 97.1633 76.5593 95.2225 76.5593H65.746L74.965 38.5219H60.7726L50.2193 81.7683C49.734 83.8276 50.2193 86.0081 51.5536 87.5829C52.8879 89.2789 54.8288 90.248 57.0122 90.248H87.0952L77.9975 142.822H98.7403L158.179 62.5073C159.755 60.448 159.998 57.6618 158.785 55.3602C157.572 53.1797 155.267 51.726 152.599 51.726Z",
    fill: "#09140E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68482f09564d9a20a8d9fdae804581ed.svg";
export { ForwardRef as ReactComponent };